import { useEffect, useState } from 'react';
import { DashboardService } from '../../../services/dashboard.service';
import { ThreadLensData, ThreadLensKey } from '../../../interfaces/threadLens.interface';

export interface ThreadLensState {
    /** null until the first answer, and after a failure. A missing section is absent from the data, never zero. */
    data: ThreadLensData | null;
    loading: boolean;
    error: boolean;
    /** True when the server answered 403: the caller does not hold the key for this lens. */
    forbidden: boolean;
}

/** One request for the whole role board: the server decides which sections the caller may see. */
export function useThreadLens(institutionId: string, lens: ThreadLensKey): ThreadLensState {
    const [state, setState] = useState<ThreadLensState>({ data: null, loading: true, error: false, forbidden: false });

    useEffect(() => {
        if (!institutionId) { setState({ data: null, loading: false, error: false, forbidden: false }); return; }
        let live = true;
        setState(s => ({ ...s, loading: true, error: false, forbidden: false }));
        DashboardService.getThreadLens(institutionId, lens)
            .then(d => { if (live) setState({ data: d, loading: false, error: false, forbidden: false }); })
            .catch((err: { response?: { status?: number } }) => {
                if (live) setState({ data: null, loading: false, error: true, forbidden: err?.response?.status === 403 });
            });
        return () => { live = false; };
    }, [institutionId, lens]);

    return state;
}
